/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Circuit_BreakersInputs */

const en_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Circuit breakers`)
};

const ar_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قواطع الدائرة`)
};

const bn_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সার্কিট ব্রেকার`)
};

const de_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leistungsschalter`)
};

const es_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disyuntores`)
};

const fr_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disjoncteurs`)
};

const pt_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disjuntores`)
};

const zh_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`断路器`)
};

const tr_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Devre kesiciler`)
};

const ru_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматические выключатели`)
};

const pl_svchip_circuit_breakers = /** @type {(inputs: Svchip_Circuit_BreakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyłączniki automatyczne`)
};

/**
* | output |
* | --- |
* | "Circuit breakers" |
*
* @param {Svchip_Circuit_BreakersInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_circuit_breakers = /** @type {((inputs?: Svchip_Circuit_BreakersInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Circuit_BreakersInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_circuit_breakers(inputs)
	if (locale === "bn") return bn_svchip_circuit_breakers(inputs)
	if (locale === "de") return de_svchip_circuit_breakers(inputs)
	if (locale === "es") return es_svchip_circuit_breakers(inputs)
	if (locale === "fr") return fr_svchip_circuit_breakers(inputs)
	if (locale === "pt") return pt_svchip_circuit_breakers(inputs)
	if (locale === "zh") return zh_svchip_circuit_breakers(inputs)
	if (locale === "tr") return tr_svchip_circuit_breakers(inputs)
	if (locale === "ru") return ru_svchip_circuit_breakers(inputs)
	if (locale === "pl") return pl_svchip_circuit_breakers(inputs)
	return en_svchip_circuit_breakers(inputs)
});